import {BaseSearchRequest} from "./baseSearchRequest";
/**
 * Created by vlad.p on 7/31/2017.
 */

export class UserSearchRequest extends BaseSearchRequest {
    public FillOrders: boolean;

    public constructor(obj : Partial<UserSearchRequest>){
        super();
        Object.assign(this,obj);
    }

}


// WEBPACK FOOTER //
// ./app/objects/requests/userSearchRequest.ts